import Rodape from "../../components/rodape";
import BusinessOtimize from "../../components/businessOtimize";
import SquadBeneficios from "../../components/squadBeneficios";
import BannerProjects from "../../components/bannerProjects";
import SquadDiferenciais from "../../components/squadDiferenciais";

function Smartsourcing() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-smartsourcing.png"
                title="/SMARTSOURCING"
                titleBold=""
                iconSrc="../assets/icone-projectiva-behub.png"
                iconAlt="Projectiva BeHub"
                iconText="be."
                iconTextBold="hub"
                descriptionBold=""
                description={
                    <>
                        <span className="font-bold">
                            Alocação estratégica de profissionais{" "}
                        </span>
                        com ampla expertise, oferecendo agilidade, produtividade
                        e eficiência na entrega de projetos.
                    </>
                }
                footerText="VERTICAL PROJECTS | Modelos de entrega"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] to-[#A002CB]"
                brand="behub"
            />
            <SquadBeneficios
                title={
                    <>
                        <p className="text-5xl font-inter-light ">
                            Benefícios desse{" "}
                            <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] bg-clip-text text-transparent relative">
                                {" "}
                                modelo de entrega
                            </span>
                        </p>
                    </>
                }
                cards={[
                    {
                        icon: "../assets/servicos/hunting_icon.svg",
                        title: "Hunting Ágil",
                        text: "Garantimos um processo de hunting eficiente e ágil, junto a um acompanhamento efetivo para potencializar talentos continuamente conforme as necessidades do negócio.",
                        glowColor: "#A002CB",
                    },
                    {
                        icon: "../assets/servicos/alocacao_icon.svg",
                        title: "Alocação Assertiva",
                        text: "Desenvolvemos um modelo único de mercado, com alocação assertiva focada também na retenção estratégica de talentos, assegurando ao seu negócio eficiência e satisfação máxima.  ",
                        glowColor: "#A002CB",
                    }
                ]}
            />
            <BusinessOtimize
                backgroundImage="../assets/background_mudancas.png"
                title={
                    <>
                        Somos referência em{" "}
                        <span className="font-inter-bold">
                            entregas efetivas que transformam negócios.
                        </span>
                    </>
                }
                buttonText="Otimize seu negócio"
                buttonLink="#"
            />
            <SquadDiferenciais
                leftColumnContent={{
                    title: (
                        <>
                            <p className="text-5xl font-inter-light ">
                                Diferenciais desse{" "}
                                <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] bg-clip-text text-transparent relative">
                                    {" "}
                                    modelo de entrega
                                </span>
                            </p>
                        </>
                    ),
                    subtitle: "Outros modelos de entrega:",
                    items: [
                        { text: "Escopo fechado", link: "/escopo-fechado" },
                        { text: "Squad", link: "/squad" },
                    ],
                    buttonText: "Otimize seu negócio",
                    buttonLink: "#",
                }}
                rightColumnItems={[
                    {
                        id: "01",
                        title: "COMPREENSÃO PROFUNDA",
                        description:
                            "Atuamos em completa parceria com a sua equipe, construindo uma jornada única e personalizada para as necessidades e objetivos específicos do seu negócio.",
                    },
                    {
                        id: "02",
                        title: "EFICIÊNCIA PROFISSIONAL",
                        description:
                            "Implementamos soluções que geram eficiência operacional em todos os aspectos do projeto, otimizam recursos e maximizam o Retorno sobre Investimento (ROI).",
                    },
                    {
                        id: "03",
                        title: "PARCERIA DE LONGO PRAZO",
                        description:
                            " Atuamos em parceria completa com nossos clientes, proporcionando suporte contínuo e assistência durante todas as etapas, inclusive, no pós-projeto.",
                    },
                    {
                        id: "04",
                        title: "ABORDAGEM HOLÍSTICA",
                        description:
                            "Entregamos excelência em resultados ao abordar não somente os sintomas, como as causas dos problemas e desafios de cada projeto.",
                    },
                    {
                        id: "05",
                        title: "RESULTADOS COMPROVADOS",
                        description:
                            "Comprovamos a nossa expertise através de nossos clientes, que confiam e atestam a qualidade e o impacto transformador de nossas entregas em negócios de diferentes complexidades e setores.",
                    },
                ]}
            />
            <Rodape />
        </>
    );
}

export default Smartsourcing;
